import { TARGET } from "../../../constants/target.qwik.mjs";
import { isEditing } from "../../../functions/is-editing.qwik.mjs";
import { isPreviewing } from "../../../functions/is-previewing.qwik.mjs";
const SDKS_USING_ELEMENT_REF_APPROACH = [
  "svelte",
  "qwik",
  "vue"
];
const needsElementRefDivForEditing = () => {
  return SDKS_USING_ELEMENT_REF_APPROACH.includes(TARGET) && (isEditing() || isPreviewing());
};
export {
  SDKS_USING_ELEMENT_REF_APPROACH,
  needsElementRefDivForEditing
};
